import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../service/server/server.service';
import { TabComponent } from '../system/service/menu/tab/tab.component';
import { MenuItemsComponent } from '../system/service/menu/menu-items/menu-items.component';
import { HttpClient, HttpEventType, JsonpClientBackend } from '@angular/common/http';
import { SaleProcessDetaileComponent } from '../sale/sale-process-detaile/sale-process-detaile.component';
import { InvoiceDetaileComponent } from '../system/wharehouse/wharehouse-invoice/invoice-detaile/invoice-detaile.component';
import { CkdDetaileComponent } from '../sale/ckd-detaile/ckd-detaile.component';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  public username: string | undefined;
  public server: string = this.serverService.get_server();
  public lang: any | undefined;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public fname: string | undefined;
  public lname: string | undefined;
  public password: any | undefined;
  public repassword: any | undefined;
  public err_password: boolean | undefined;
  public err_password_message: any | undefined;
  public password_validation: any | undefined;
  public repassword_validation: any | undefined;
  public obj_change_password: any | undefined;
  public list_process: any = [];
  status_title: string | undefined;
  uploadedAvaterProgess: number | undefined;
  user_logo: string = this.serverService.get_default_user_logo();
  user_id: number | undefined;
  user_info: any | undefined;
  site: string | undefined;
  list_tab: any = [];
  list_tab_temp: any = [];
  tab_id: number = 156;
  list_section: any = [];
  list_section_temp: any = [];
  list_rstatus: any = [];
  rstatus_id: number | undefined;
  store_id: number | undefined;
  type: number = 1;
  i: number | undefined;
  select_i: number | undefined;
  action: string | undefined;
  id: number | undefined;
  list_menu: any = []; list_menus: any = [];
  setting_menu: boolean = false;
  admin: any | undefined;
  services_id: number | undefined;
  user_title: string | undefined;
  show_extra_menu: boolean = true;
  groups_title: string | undefined;
  version: string | undefined;
  version_show_alarm: boolean = false;
  job: number | undefined;
  menu_id: number | undefined;
  list_cate: any = [];
  list_software: any = [];
  list_invoice_type: any = [];
  invoice_type: number;
  product: number;
  status_service_id: number;
  process_id: number;
  ckd_id: number;
  ckd_status_id: number;
  type_get_cate: string | undefined;

  sex_title: string | undefined;
  customer_title: string | undefined;
  customer_cellphone: string | undefined;
  token: any | undefined;


  list_group: any = [];
  list_ckd: any = [];
  group_id: string | undefined;
  cate_id: string | undefined;
  user_creator: number | undefined;
  refrerr: any | undefined;
  material_cate: string | undefined;
  list_ckd_status: any = [];


  @ViewChild('myModalPassword', { static: true }) myModalPassword: any;
  constructor(public router: Router, public serverService: ServerService
    , public matSnackBar: MatSnackBar
    , public dialog: MatDialog
  ) {
    /*
    this.serverService.get_version().subscribe(
      (version) => {

        var version_prev = localStorage.getItem("version");
        this.version = version;
        if (version_prev != this.version) {
          this.version_show_alarm = true;
        }
        else {
          this.version_show_alarm = false;
        }
      }
    )
    */

    this.serverService.get_services_id().subscribe(
      (res) => {
        this.get_services_id(res);
      }
    )

    this.serverService.get_reset().subscribe(
      (res) => {
        this.list_cate = [];
        this.list_group = [];
        this.list_ckd = [];
        this.list_process = [];
        this.list_invoice_type = [];
        this.list_ckd_status = [];
      }
    )

    this.serverService.get_ckd().subscribe(
      (res) => {
        this.get_ckd();
      }
    )

    this.serverService.get_ckd_status().subscribe(
      (res) => {
        this.get_ckd_status();
      }
    )

    this.serverService.get_group().subscribe(
      (res) => {
        this.get_group();
      }
    )

    this.serverService.get_cate().subscribe(
      (res) => {
        this.material_cate = res;
        if (res == 'material') this.get_cate(10553, 'material');
        else if (res == 'cate2') this.get_cate(10539, 'cate2');

      }
    )

    this.serverService.get_shop_process().subscribe(
      (res) => {
        if (res) {
          this.product = res.product;
          this.status_service_id = res.service_id;
          this.get_process();
        }
      }
    )


    this.serverService.get_invoice_type().subscribe(
      (res) => {
        this.get_invoice_type();
      }
    )

    this.serverService.get_tab().subscribe(
      (res: any) => {
        if (res.action == 'insert') {
          this.list_tab.push(res.result);
          this.list_tab_temp[res.result.site_tab_id] = new Array();
        }
        if (res.action == 'update') {
          for (var i = 0; i < this.list_tab.length; i++) {
            if (this.list_tab[i].site_tab_id == res.result.id) {
              this.list_tab[i].site_tab_title = res.result.title;
            }
          }
        }
        if (res.action == 'delete') {
          for (var i = 0; i < this.list_tab.length; i++) {
            if (this.list_tab[i].site_tab_id == res.result) {
              this.list_tab.splice(i, 1)
            }
          }
        }//end if delete tab
        if (res.action == 'sort') {
          for (var x = 0; x < this.list_tab.length; x++) {
            for (var i = 0; i < res.result.data.length; i++) {
              if (this.list_tab[x].site_tab_id == res.result.data[i].site_tab_id) {
                this.list_tab[x].site_tab_sort = i + 1;
              }
            }
          }
          this.list_tab.sort(this.compare_tab);
        }
        if (res.action == 'select') {
          if (res.result) {
            $(document).ready(function () {
              $(".active").removeClass("active");
              $("#a" + res.result).addClass("active");
              $("#" + res.result).addClass("active");
            })
          }
        }
        if (res.action == 'status') {
          if (res.result.site_tab_status == 2) {
            for (var i = 0; i < this.list_tab.length; i++) {
              if (this.list_tab[i].site_tab_id == res.result.site_tab_id) {
                this.list_tab.splice(i, 1)
              }
            }
          }
          else {
            this.list_tab.push(res.result);
            this.list_tab.sort(this.compare_tab);
          }
        }
      }
    )

    this.serverService.get_section().subscribe(
      (res: any) => {
        if (res.action == 'insert') {
          this.list_section.push(res.result.data);
          this.list_tab_temp[res.result.tab_id].push(res.result.data);
          this.list_tab_temp[res.result.tab_id].sort(this.compare_section);
        }
        if (res.action == 'update') {
          for (var i = 0; i < this.list_section.length; i++) {
            if (this.list_section[i].site_section_id == res.result.id) {
              this.list_section[i].site_section_title = res.result.title;
            }
          }
        }
        if (res.action == 'delete') {
          for (var i = 0; i < this.list_tab_temp[res.result.tab_id].length; i++) {
            if (this.list_tab_temp[res.result.tab_id][i].site_section_id == res.result.section_id) {
              this.list_tab_temp[res.result.tab_id].splice(i, 1);
            }
          }
        }//end if delete tab
        if (res.action == 'sort') {
          for (var x = 0; x < this.list_tab_temp[res.result.tab_id].length; x++) {
            for (var i = 0; i < res.result.data.length; i++) {
              if (this.list_tab_temp[res.result.tab_id][x].site_section_id == res.result.data[i].site_section_id) {
                this.list_tab_temp[res.result.tab_id][x].site_section_sort = i + 1;
              }
            }
          }
          this.list_tab_temp[res.result.tab_id].sort(this.compare_section);
        }
        if (res.action == 'status') {
          if (res.result.data.site_section_status == 2) {
            for (var i = 0; i < this.list_section.length; i++) {
              if (this.list_section[i].site_section_id == res.result.data.site_section_id) {
                this.list_section.splice(i, 1);
              }
            }
            for (var i = 0; i < this.list_tab_temp[res.result.tab_id].length; i++) {
              if (this.list_tab_temp[res.result.tab_id][i].site_section_id == res.result.data.site_section_id) {
                this.list_tab_temp[res.result.tab_id].splice(i, 1);
              }
            }
          }
          else {
            this.list_section.push(res.result.data);
            this.list_tab_temp[res.result.tab_id].push(res.result.data);
            this.list_tab_temp[res.result.tab_id].sort(this.compare_section);
          }
        }
      }
    )


    this.serverService.get_menu().subscribe(
      (res: any) => {
        if (res.action == 'insert') {
          this.list_menus[res.result.section_id] = [];
          for (var i = 0; i < res.result.data.length; i++) {
            if (res.result.data[i].shop_services_img) {
              res.result.data[i].src = res.result.data[i].shop_services_site + "/" + res.result.data[i].shop_services_img;
            } else {
              res.result.data[i].src = this.serverService.get_default_image();
            }

            if (res.result.data[i].shop_services_status == 1) {
              this.list_menus[res.result.section_id].push(res.result.data[i]);
            }

          }
        }
        if (res.action == 'remove') {
          for (var i = 0; i < this.list_menus[res.result.section_id].length; i++) {
            if (this.list_menus[res.result.section_id][i].site_menu_id == res.result.menu_id) {
              this.list_menus[res.result.section_id].splice(i, 1);
            }
          }
        }
        if (res.action == 'update') {
          for (var i = 0; i < this.list_menus[res.result.section_id].length; i++) {
            if (this.list_menus[res.result.section_id][i].shop_services_id == res.result.id) {
              this.list_menus[res.result.section_id][i].shop_services_title = res.result.title;
            }
          }
        }
        if (res.action == 'logo') {
          for (var i = 0; i < this.list_menus[res.result.menu_section].length; i++) {
            if (this.list_menus[res.result.menu_section][i].site_menu_id == res.result.menu_id) {
              if (res.result.data.path) {
                this.list_menus[res.result.menu_section][i].src = res.result.data.site + "/" + res.result.data.path;
              } else {
                this.list_menus[res.result.menu_section][i].src = this.serverService.get_default_image();
              }
            }
          }
        }
        if (res.action == 'status') {
          if (res.result.data.shop_services_status == 2) {
            for (var i = 0; i < this.list_menus[res.result.section_id].length; i++) {
              if (this.list_menus[res.result.section_id][i].shop_services_id == res.result.data.shop_services_id) {
                this.list_menus[res.result.section_id].splice(i, 1);
              }
            }
          }
          else {
            if (res.result.data.shop_services_img) {
              res.result.data.src = res.result.data.shop_services_site + "/" + res.result.data.shop_services_img;
            } else {
              res.result.data.src = this.serverService.get_default_image();
            }
            this.list_menus[res.result.section_id].push(res.result.data);
            this.list_menus[res.result.section_id].sort(this.compare_menus);
          }
        }
      }
    )
  }

  select(id: number) {
    this.tab_id = id;
    $(".active").removeClass("active");
    $("#a" + id).addClass("active");
    $("#" + id).addClass("active");
  }


  ngOnInit() {
    this.serverService.status1(2);
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.refrerr = JSON.parse(<any>localStorage.getItem('refrerr'));

    this.server = this.serverService.get_server();
    this.site = this.serverService.get_site();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));

    if (this.user_info) {
      this.user_id = this.user_info.user_id;
      this.username = this.user_info.username;
      this.admin = 1;
      this.user_title = this.user_info.user_title;
      this.groups_title = this.user_info.groups_title;
      this.job = this.user_info.job;
      this.user_creator = this.user_info.user_creator;
    }
    this.get_tab();
    this.get_logo();
    this.get_invoice_type();
  }

  get_ckd_status() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10589 }).subscribe(
      (res: any) => {
        this.list_invoice_type = [];
        this.list_process = [];
        this.list_group = [];
        this.list_ckd = [];
        this.list_cate = [];
        this.list_ckd_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_ckd_status.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_process() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1523, id: this.product, user_id: this.user_id }).subscribe(
      (res: any) => {
        this.list_invoice_type = [];
        this.list_process = [];
        this.list_group = [];
        this.list_ckd = [];
        this.list_cate = [];
        this.list_ckd_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_process.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_invoice_type() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6018 }).subscribe(
      (res: any) => {
        this.list_invoice_type = [];
        this.list_process = [];
        this.list_group = [];
        this.list_ckd = [];
        this.list_cate = [];
        this.list_ckd_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            res['result'][i].logo = res['result'][i].wharehouse_invoice_type_site + "/" + res['result'][i].wharehouse_invoice_type_logo;
            this.list_invoice_type.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  go_invoice_type(id: number) {
    this.invoice_type = id;
    this.router.navigate(['/home/invoice/188', id])
  }


  open_show_extra_menu() {
    this.show_extra_menu = !this.show_extra_menu;
  }

  change_version() {
    localStorage.clear();
    location.reload();
  }

  get_tab() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1004, software_id: this.serverService.get_software_id() }).subscribe(
      (res: any) => {
        this.list_tab = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].site_tab_title) {
              res['result'][i].width = Number(res['result'][i].site_tab_title.length + 5);
            }
            this.list_tab.push(res['result'][i]);
            this.list_tab_temp[res['result'][i].site_tab_id] = new Array();
          }//end for
          this.tab_id = res['result'][0].site_tab_id;
          this.get_section();
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end get_tab


  get_section() {
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1021, software_id: this.serverService.get_software_id() }).subscribe(
      (res: any) => {
        this.list_section = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_section.push(res['result'][i]);
            for (var j = 0; j < this.list_tab.length; j++) {
              this.list_tab[j].show = false;
              if (this.list_tab[j].site_tab_id == res['result'][i].site_section_tab) {
                this.list_tab_temp[this.list_tab[j].site_tab_id].push(res['result'][i]);
              }
            }
            this.list_menus[res['result'][i].site_section_id] = new Array();
          }//end for
          this.get_menu();
          //res['result'][i].width = Number(res['result'][i].site_section_title.length + 5);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end get_section

  open_add_section() {
    const dialogRef = this.dialog.open(TabComponent, {
      width: '60rem',
      height: 'auto',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        //this.get_tab();
      }
    )
  }

  compare_tab(a: any, b: any) {
    let comparison = 0;
    if (a.site_tab_sort > b.site_tab_sort) {
      comparison = 1;
    } else if (a.site_tab_sort < b.site_tab_sort) {
      comparison = -1;
    }
    return comparison;
  }

  compare_section(a: any, b: any) {
    let comparison = 0;
    if (a.site_section_sort > b.site_section_sort) {
      comparison = 1;
    } else if (a.site_section_sort < b.site_section_sort) {
      comparison = -1;
    }
    return comparison;
  }

  compare_menus(a: any, b: any) {
    let comparison = 0;
    if (a.site_menu_sort > b.site_menu_sort) {
      comparison = 1;
    }
    else if (a.site_menu_sort < b.site_menu_sort) {
      comparison = -1;
    }
    return comparison;
  }

  open_process(id: number) {
    this.process_id = id;
    if (this.setting_menu == true) {
      this.dialog.open(SaleProcessDetaileComponent, {
        width: '45rem',
        height: 'auto',
        data: { id: id }
      })
    } else {
      this.router.navigate(['/home/sale/', this.status_service_id, this.product, id]);
    }
  }

  open_status_ckd(id: number) {
    this.ckd_status_id = id;
    this.router.navigate(['/home/ckd/222'], { queryParams: { status: id } });
  }

  open_menu(i: number, link: string, id: number, title: string, section: any) {
    if (this.setting_menu == true) {
      this.open_menu_item(i, id, title, section);
      this.menu_id = id;
      this.rstatus_id = 0;
    }

    else {
      if (id == 32) {
        this.menu_id = 32;
        this.router.navigate(['/home/sale', id, 1, 1]);
      }
      else if (id == 33) {
        this.menu_id = 33;
        this.router.navigate(['/home/sale', id, 2, 1]);
      }
      else if (id == 34) {
        this.menu_id = 34;
        this.router.navigate(['/home/sale', id, 3, 1]);
      }
      else if (id == 35) {
        this.menu_id = 35;
        this.router.navigate(['/home/sale', id, 4, 1]);
      }
      else if (id == 215) {
        this.new();
      }
      else {
        this.router.navigate(['/home', link, id]);
        this.menu_id = id;
        this.rstatus_id = 0;
      }
    }
    this.services_id = id;
  }

  open_menu_item(i: number, id: number, title: string, section_id: string) {
    const dialogRef = this.dialog.open(MenuItemsComponent, {
      width: '45rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, title: title, type_task: 2 }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.serverService.send_menu({ title: res.result.shop_services_title, id: res.result.shop_services_id, section_id: section_id }, 'update');

        }
      }
    )
  }

  new() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6015, id: 215, user_id: this.user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          var new_invoice_id;
          if (res['num'] == 1) {
            new_invoice_id = Number(res['result'][0].wharehouse_invoice_number) + 1;
          } else {
            new_invoice_id = Number(1);
          }
          this.open_detaile(-1, 2, res['id'], new_invoice_id);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  open_detaile(i: number, type_task: number, id: number, new_invoice_id: number) {
    const dialogRef = this.dialog.open(InvoiceDetaileComponent, {
      width: '75rem',
      height: 'auto',
      disableClose: true,
      data: { type_task: 2, id: id, new_invoice_id: new_invoice_id, code: 188, title: '', invoice_type_id: 0 }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.serverService.send_invoice(res.result);
          this.router.navigate(['/home/invoice/188/0']);
        }
        //this.update_financial2(res);
      }
    )
  }


  get_menu_item(i: number, section: string, id: number) {
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1028, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_menus[section][i].shop_services_title = res['result'][0].shop_services_title;
          this.list_menus[section][i].shop_services_site = res['result'][0].shop_services_site;
          this.list_menus[section][i].shop_services_img = res['result'][0].shop_services_img;
          this.list_menus[section][i].src = res['result'][0].shop_services_site + "/" + res['result'][0].shop_services_img;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  go_to_user() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1660, id: this.user_creator }).subscribe(
      (res: any) => {
        localStorage.clear();
        if (res['status'] == 1) {
          var user_info = {
            user_id: res['result'][0].user_id,
            username: res['result'][0].user_userName,
            user_title: res['result'][0].user_title,
            groups_title: res['result'][0].user_groups_title,
            lang: this.lang,
          };
          localStorage.setItem("user_info", JSON.stringify(user_info));
          localStorage.setItem('status', '1');
          localStorage.setItem('refrerr', '1');
          localStorage.setItem('lang', this.lang);
          //window.open(this.serverService.get_current_site() + "/home/user/161", "_self");
          window.open("/home/user/24?group=2", "_self");
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_services_id(id: number) {
    this.menu_id = id;
  }

  //**************************************************************************************************** */
  get_menu() {
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1005, user_id: this.user_id, software_id: this.serverService.get_software_id() }).subscribe(
      (res: any) => {
        this.list_menu = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].shop_services_img) {
              res['result'][i].src = res['result'][i].shop_services_site + "/" + res['result'][i].shop_services_img;
            } else {
              res['result'][i].src = this.serverService.get_default_image();
            }
            this.list_menu.push(res['result'][i]);
          }//end for
          this.join_section_menu();
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end get_menu res['result'][i].site_section_tab

  join_section_menu() {
    for (var i = 0; i < this.list_section.length; i++) {
      for (var j = 0; j < this.list_menu.length; j++) {
        if (this.list_section[i].site_section_id == this.list_menu[j].site_menu_section) {
          this.list_menus[this.list_section[i].site_section_id].push(this.list_menu[j]);

          for (var x = 0; x < this.list_tab.length; x++) {
            if (this.list_tab[x].site_tab_id == this.list_section[i].site_section_tab) {
              this.list_tab[x].show = true;
            }//end if
          }
        }
      }
    }
  }


  change_avater(event: any) {
    var selectedavater: File = <File>event.target.files[0];
    var fd = new FormData();
    fd.append("image", selectedavater, selectedavater.name);
    this.serverService.post_address_file(this.server, "uploadImage", fd)
      .subscribe(
        (event: any) => {
          if (event.type == HttpEventType.UploadProgress) {
            this.uploadedAvaterProgess = (event.loaded / event.total) * 100;
          }
          else if (event.type === HttpEventType.Response) {
            this.update_avater_user(event);
          }
        }
      )
  }

  update_avater_user(result: any) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      address: 1037,
      user_id: this.user_id,
      site: this.serverService.get_site_upload_image(),
      path: this.serverService.get_path_upload_image() + "/" + result.body.result.filename
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.user_logo = res['result'][0].user_logo_site + "/" + res['result'][0].user_logo;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_cate(address, type) {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: address }).subscribe(
      (res: any) => {
        this.type_get_cate = type;
        this.list_invoice_type = [];
        this.list_process = [];
        this.list_group = [];
        this.list_ckd = [];
        this.list_cate = [];
        this.list_ckd_status = [];

        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_cate.push(res['result'][i]);
          }//end for
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  get_ckd() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10599 }).subscribe(
      (res: any) => {
        this.list_invoice_type = [];
        this.list_process = [];
        this.list_group = [];
        this.list_ckd = [];
        this.list_cate = [];
        this.list_ckd_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_ckd.push(res['result'][i]);
          }//end for
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }



  get_group() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10494 }).subscribe(
      (res: any) => {
        this.list_invoice_type = [];
        this.list_process = [];
        this.list_group = [];
        this.list_ckd = [];
        this.list_cate = [];
        this.list_ckd_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_group.push(res['result'][i]);
          }//end for
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_menu1(id: number, sex_title: string, customer_title: string, customer_cellphone: string, token: number, status_title: string) {
    this.ckd_id = id;
    this.status_title = status_title;
    this.sex_title = sex_title;
    this.customer_title = customer_title;
    this.customer_cellphone = customer_cellphone;
    this.token = token;
  }

  go_to_ckd(id: any) {
    this.ckd_id = id;
    if (id == 'partner') this.router.navigate(['/home/ckd/222'], { queryParams: { ckd: id } });
    else this.router.navigate(['/home/ckd-material2/224'], { queryParams: { ckd: id } });
  }

  open_ckd(id: number) {
    this.ckd_id = id;
    this.dialog.open(CkdDetaileComponent, {
      width: '85rem',
      height: 'auto',
      disableClose: true,
      data: { type_task: 2, id: id, search_array: [], code: 224, readonly: true }
    });
  }


  go_to_group(id: any) {
    this.group_id = id;
    if (id == 'partner') this.router.navigate(['/home/user/24'], { queryParams: { group: id } });
    else this.router.navigate(['/home/user/24'], { queryParams: { group: id } });
  }

  go_to_cate(id: any) {
    this.cate_id = id;
    if (this.material_cate == 'material') this.router.navigate(['/home/material/171'], { queryParams: { id: id } });
    else this.router.navigate(['/home/material-cate2/220'], { queryParams: { id: id } });
  }

  get_logo() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1038, user_id: this.user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].user_logo) {
            this.user_logo = res['result'][0].user_logo_site + "/" + res['result'][0].user_logo;
          }
          else {
            this.user_logo = this.serverService.get_default_user_logo();
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  go_to_status(id: number) {
    this.rstatus_id = id;
    this.router.navigate(['/home', 'reception', 170, id]);
    this.menu_id = 0;
  }

  go_to_store(id: number) {
    this.store_id = id;
    this.router.navigate(['/home', 'store', 185, id]);
    this.menu_id = 0;
  }

  get_software() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1047 }).subscribe(
      (res: any) => {
        this.list_software = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            res['result'][i].logo = res['result'][i].site_software_site_logo + "/" + res['result'][i].site_software_logo;
            this.list_software.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  //********************************************************************************************** */
  access_setting_menu() {
    this.setting_menu = !this.setting_menu;
  }
  //********************************************************************************************** */
  convertToInt(event: any) {
    return parseInt(event.target.value);
  }

  //***********************************************************************************
  change_address(type: any) {
    if (type == 1) {
      this.router.navigate(['/home', 'supplier-goods-list']);
    }//1
    if (type == 2) {
      this.router.navigate(['/home', 'supplier-new-contact']);
    }//2
    if (type == 3) {
      localStorage.setItem('go_menu', '1');
      this.router.navigate(['/home', 'supplier-contract1-list']);
    }//3
  }
  //***********************************************************************************
  open_modal_password() {
    this.myModalPassword.open();
    this.password = "";
    this.repassword = "";
    this.err_password = false;
  }

  change_password() {

  }//end change_password
  //***********************************************************************************
  signout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }//end signout

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 5000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //************************************************************************************
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }

}
